import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { DOCUMENT } from "@angular/common";
import { RouterOutlet } from "@angular/router";
import { TranslocoService } from "@jsverse/transloco";
import { GlobalLoaderComponent } from "./core/components/global-loader/global-loader.component";
import { SnackbarNotificationModule } from "./core/modules/snackbar-notification/snackbar-notification.module";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, GlobalLoaderComponent, SnackbarNotificationModule],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  private readonly document = inject(DOCUMENT);
  private readonly translocoService = inject(TranslocoService);

  constructor() {
    // L'attributo `lang` del documento deve dire la verità: è quello che
    // legge un lettore di schermo per scegliere la voce, ed è anche quello da
    // cui Iubenda deduce la lingua quando non gliela si dice. Lo imposta già
    // lo script in `index.html` al caricamento; qui lo si tiene aggiornato
    // quando la lingua cambia a pagina aperta.
    this.translocoService.langChanges$
      .pipe(takeUntilDestroyed())
      .subscribe((lang) => {
        this.document.documentElement.lang = lang.split("-")[0];
      });
  }
}
